import React, { useState } from "react";
import { Typography, Button, Box } from "@material-ui/core";
import { useStyles } from "../../../../modules/Checkins/Overview/LeftPanel/styles";
// import { CHARACTER_LIMIT_FOR_VISION_DESCRIPTION, CHARACTER_LIMIT_FOR_RESPONSE } from "../../../../constants";
import { CHARACTER_LIMIT_FOR_VISION_DESCRIPTION } from "../../../../constants";
// import { wrap } from "lodash";

const ShowMoreButton = (props) => {
  const classes = useStyles();
  let { description, showDescription } = props;
  const [showLessDetails, setShowLessDetails] = useState(false);
  const htmlNode = document.createElement("p");
  htmlNode.innerHTML = description;
  htmlNode.querySelectorAll("*").forEach(function (node) {
    node.removeAttribute("style");
  });
  description = htmlNode.innerHTML;
  return (
    <div>
      <Typography
        className={`${showDescription ? classes.textSize : ""} ${classes.formattedText
          } ${description.length >
            (props?.charLimit
              ? props?.charLimit
              : CHARACTER_LIMIT_FOR_VISION_DESCRIPTION) && !showLessDetails
            ? classes.shortContent
            : ""
          }`}
      >
        <div
          className={`${showLessDetails ? "" : "multi-wrap-3"} format-txt`}
          dangerouslySetInnerHTML={{
            __html: showLessDetails
              ? description
              : description
                ? `${description.slice(
                  0,
                  props?.charLimit
                    ? props?.charLimit
                    : CHARACTER_LIMIT_FOR_VISION_DESCRIPTION
                )}`
                : "",
            // __html: description
          }}
        />
      </Typography>
      {description.length >
        (props?.charLimit
          ? props?.charLimit
          : CHARACTER_LIMIT_FOR_VISION_DESCRIPTION) ? (
        <Box>
          <Button
            data-testid='click'
            onClick={() => setShowLessDetails(!showLessDetails)}
            color="primary"
            size="small"
            className="p0 font-13"
          >
            {showLessDetails ? "Show less" : "Show more"}
          </Button>
        </Box>
      ) : null}
    </div>
  );
};

export default ShowMoreButton;
